import { todayCards } from "@/mocks/home";

export default function TodayGrid() {
  return (
    <section id="today" className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100/60 border-y hairline">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-12">
        <div>
          <span className="text-xs md:text-sm tracking-[0.3em] text-accent-700 uppercase">
            Today&apos;s Picks
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            今日新料 · 图文速览
          </h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
            把今天最值得追的几条整理成图文卡片，一眼判断值不值得点开，
            适合只想快速追新料的你。
          </p>
        </div>
        <span className="inline-flex items-center gap-2 px-3 py-2 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm whitespace-nowrap">
          <i className="ri-layout-grid-line text-base" />
          共 6 条精选
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-7">
        {todayCards.map((card) => (
          <article
            key={card.id}
            className="group flex flex-col rounded-lg border hairline bg-background-50 overflow-hidden hover:border-primary-300 transition-colors"
          >
            <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
              <img
                src={card.image}
                alt={`${card.title} - 爱黑料网今日更新`}
                title={`${card.title} · 爱黑料网最快黑料`}
                className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-foreground-950/85 text-background-50 text-xs font-medium backdrop-blur whitespace-nowrap">
                {card.tag}
              </span>
            </div>
            <div className="flex flex-col flex-1 p-4 md:p-5">
              <h3 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950">
                {card.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">
                {card.excerpt}
              </p>
              <div className="mt-4 pt-4 border-t hairline flex items-center justify-between gap-3">
                <span className="text-xs text-foreground-500 truncate">{card.source}</span>
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-600 whitespace-nowrap">
                  <i className="ri-eye-line text-sm" />
                  {card.reads}
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}